module.exports = __webpack_public_path__ + "img/thumb-vdoc.2c041bfe.png";